var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-horizontal tsForm",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-lg-12 col-form-label"},[_vm._v("CHANGELOG")]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 changelog-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42930899","hasScoped":false,"buble":{"transforms":{}}}!./src/components/external/changelog/changelog.html
// module id = 609
// module chunks = 15